import LoginUtil from '../../../util/LoginUtil';

export default {
    headerFields: [
        {
            name: "id",
            label: "ID",
            formVisible: false
        },
        {
            name: "username",
            label: "Felhasználónév",
            formReadOnly: true,
            formVisible: true,
            formType: "text",
            formSize: 3
        },
        {
            name: "emailAddress",
            label: "E-mail cím",
            formReadOnly: true,
            formVisible: true,
            formType: 'text',
            formSize: 3
        },
        {
            name: "firstName",
            label: "Vezetéknév",
            formType: 'text',
            formSize: 3,
            formVisible: true
        },
        {
            name: "lastName",
            label: "Keresztnév",
            formType: 'text',
            formSize: 3,
            formVisible: true
        },
        {
            name: "phone",
            label: "Telefonszám",
            formType: 'tel',
            formSize: 3,
            formVisible: true
        },
        {
            name: "oldPassword",
            label: "Régi jelszó",
            formType: 'password',
            formSize: 3,
            formVisible: LoginUtil.isDevLoginType(),
        },
        {
            name: "newPassword1",
            label: "Új jelszó",
            formType: 'password',
            formSize: 3,
            formVisible: LoginUtil.isDevLoginType(),
        },
        {
            name: "newPassword2",
            label: "Új jelszó újra",
            formType: 'password',
            formSize: 3,
            formVisible: LoginUtil.isDevLoginType(),
        },
        {
            name: "ojoteUsername",
            label: "OJOTE felhasználónév",
            formType: 'text',
            formSize: 3,
            formVisible: true
        },
        {
            name: "ojotePassword",
            label: "OJOTE jelszó",
            formType: 'password',
            formSize: 3,
            formVisible: true
        },
        {
            name: "pacsUsername",
            label: "PACS felhasználónév",
            formType: 'text',
            formSize: 3,
            formVisible: true
        },
        {
            name: "pacsPassword",
            label: "PACS jelszó",
            formType: 'password',
            formSize: 3,
            formVisible: true
        },
        {
            name: "picture",
            label: "Kép",
            formVisible: false
        }
    ],
    missingPACSHeaderFields: [
        {
            name: "pacsUsername",
            label: "PACS felhasználónév",
            formType: 'text',
            formSize: 6,
            formVisible: true,
            formRequired: true
        },
        {
            name: "pacsPassword",
            label: "PACS jelszó",
            formType: 'password',
            formSize: 6,
            formVisible: true,
            formRequired: true
        },
    ],
    loginPACSHeaderFields: [
        {
            name: "pacsUsername",
            label: "PACS felhasználónév",
            formType: 'text',
            formSize: 6,
            formVisible: true,
            formRequired: true
        },
        {
            name: "pacsPassword",
            label: "PACS jelszó",
            formType: 'password',
            formSize: 6,
            formVisible: true,
            formRequired: true
        },
        {
            name: "loginConsent",
            label: "Mentéshez hozzájárulok",
            formType: 'checkbox',
            formSize: 3,
            formVisible: true
        }
    ]
}
